import { JSX } from "react";

import {
  CommonErrorBoundary,
  ConfigurationSummaryDisplay,
} from "@plansoft-configuration-renderer/components";
import { useConfigurationLanguage } from "@plansoft-configuration-renderer/framework";

import { useSummary } from "./useSummary";

export function SummaryContainer(): JSX.Element {
  const localeId = useConfigurationLanguage();

  const summary = useSummary();

  return (
    <CommonErrorBoundary>
      {summary.data && (
        <ConfigurationSummaryDisplay
          languageCode={localeId}
          data={summary.data}
        />
      )}
    </CommonErrorBoundary>
  );
}
